import React, { useState } from "react";
import EditableTableComponent from "../../../Components/Table/EditableTable";

const IndustryInsights = () => {
  const [extraInputValue, setExtraInputValue] = useState("");
  const handleExtraInputChange = (e) => {
    setExtraInputValue(e.currentTarget.textContent);
  };
  const columns = [
    { header: "", accessor: "bo", width: "150px" },
    { header: "Add Month", accessor: "month1" },
    { header: "Add Month", accessor: "month2" },
    { header: "Add Month", accessor: "month3" },
  ];

  const initialData = [
    {
      bo: "Add Text",
      month1: "Add Text",
      month2: "Add Text",
      month3: "Add Text",
    },
    {
      bo: "Add Text",
      month1: "Add Text",
      month2: "Add Text",
      month3: "Add Text",
    },
    {
      bo: "Add Text",
      month1: "Add Text",
      month2: "Add Text",
      month3: "Add Text",
    },
  ];

  return (
    <div>
      <EditableTableComponent
        columns={columns}
        initialData={initialData}
        heading={"Industry Insights"}
      />
      <div className="mt-4">
        <div
          contentEditable
          suppressContentEditableWarning={true}
          onBlur={handleExtraInputChange}
          className="w-full border border-zinc-500 rounded-md p-2 text-[10px]"
          style={{
            minHeight: "10px",
            whiteSpace: "normal",
            wordWrap: "break-word",
            wordBreak: "break-word",
            overflowWrap: "break-word",
          }}
        >
          {extraInputValue}
        </div>
      </div>
    </div>
  );
};

export default IndustryInsights;
